export const HOST = ['https://up-dev.play-analytics.com', 'https://up.play-analytics.com'];
export const API = {
    getDownloadPcLink: '/app/upgrade/latest' // https://wiki.tigerbrokers.net/pages/viewpage.action?pageId=20618558
};
